import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useDbContext } from "../../../context/DbContext";
import {
  fetchAllFinancialYears,
  selectActiveFy,
  selectAllFinancialYears,
  setActiveFinancialYear,
} from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";

const StatusBar = () => {
  const dispatch = useDispatch();
  const { dbCode } = useDbContext();
  const activeFy = useSelector(selectActiveFy);
  const allYears = useSelector(selectAllFinancialYears);
  const activeLocation = useSelector(selectActiveLocation);

  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (dbCode) {
      dispatch(fetchAllFinancialYears(dbCode));
    }
  }, [dbCode, dispatch]);

  const formatDateToDisplay = (dateStr) => {
    if (!dateStr) return "";
    const cleanDateStr = dateStr.toString().trim().split(/[\sT]+/)[0];
    if (cleanDateStr.includes("/") && cleanDateStr.length === 10) return cleanDateStr;
    if (/[a-zA-Z]/.test(cleanDateStr)) return cleanDateStr;
    const d = new Date(cleanDateStr);
    if (isNaN(d.getTime())) return cleanDateStr;
    const day = String(d.getDate()).padStart(2, "0");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day}/${months[d.getMonth()]}/${d.getFullYear()}`;
  };

  const formatDate = (d) => {
    const day = String(d.getDate()).padStart(2, "0");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day}/${months[d.getMonth()]}/${d.getFullYear()}`;
  };

  const formatTime = (d) => {
    let h = d.getHours();
    const m = String(d.getMinutes()).padStart(2, "0");
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m} ${ampm}`;
  };

  const handleFyChange = (e) => {
    const selectedId = parseInt(e.target.value);
    const selectedYearObj = allYears.find(
      (y) => (y.ID || y.Fyid) === selectedId
    );
    if (selectedYearObj) {
      dispatch(
        setActiveFinancialYear({
          fyid: selectedYearObj.ID || selectedYearObj.Fyid,
          Fyid: selectedYearObj.ID || selectedYearObj.Fyid,
          fromDate: selectedYearObj.FromDate || selectedYearObj.Frmdate,
          FromDate: selectedYearObj.FromDate || selectedYearObj.Frmdate,
          toDate: selectedYearObj.ToDate || selectedYearObj.Todate,
          ToDate: selectedYearObj.ToDate || selectedYearObj.Todate,
          status: selectedYearObj.Status,
          narration: selectedYearObj.Narration,
        })
      );
      window.location.reload();
    }
  };

  const locationName = activeLocation?.name || sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation") || "SHOP";

  return (
    <div className="bg-[#11235a] text-white text-[10px] xl:text-[11px] flex items-center justify-between box-border px-2 md:px-4 h-8 w-full shrink-0 border-t border-white/10 z-30 font-inter">
      <div className="flex items-center space-x-3 lg:space-x-6 overflow-hidden min-w-0">
        {/* Financial Year Select */}
        <div className="flex items-center space-x-1 lg:space-x-2 shrink-0">
          <span className="opacity-70 font-medium hidden sm:block">
            Financial Year
          </span>
          <select
            value={activeFy?.fyid || ""}
            onChange={handleFyChange}
            className="bg-transparent text-white border border-white/20 rounded px-1 py-0.5 text-[10px] xl:text-[11px] font-inter focus:outline-none focus:border-white/50 cursor-pointer"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {allYears.map((year) => {
              const id = year.ID || year.Fyid;
              const fromStr = formatDateToDisplay(year.FromDate || year.Frmdate);
              const toStr = formatDateToDisplay(year.ToDate || year.Todate);
              return (
                <option key={id} value={id} className="bg-[#11235a] text-white font-inter">
                  {fromStr} - {toStr}
                </option>
              );
            })}
          </select>
        </div>

        {/* Selected Year Dates */}
        <span className="opacity-80 shrink-0 hidden md:block">
          ({formatDateToDisplay(activeFy?.fromDate)} - {formatDateToDisplay(activeFy?.toDate)})
        </span>

        {/* Database Name */}
        <div className="flex items-center space-x-1 shrink-0">
          <span className="font-bold opacity-70">DB:</span>
          <span className="font-bold text-yellow-400">
            {dbCode || "SherGold ERP"}
          </span>
        </div>

        {/* Location Info */}
        <span className="text-yellow-400 font-bold tracking-wide shrink-0 uppercase">
          Location: {locationName}
        </span>

        <span className="opacity-90 shrink-0 hidden sm:block">Offline</span>
        <span className="opacity-90 shrink-0 hidden lg:block">
          1 Device Online
        </span>
      </div>

      <div className="flex items-center space-x-3 lg:space-x-6 opacity-90 font-medium shrink-0 ml-4 whitespace-nowrap ">
        <span className="hidden sm:block">ENG</span>
        <span>{formatDate(now)}</span>
        <span>{formatTime(now)}</span>
      </div>
    </div>
  );
};

export default StatusBar;
